// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectCategories_K37Lzq01M8H_dkVlJJlR{display:flex;align-items:baseline;gap:1em}.SelectCategories_K37Lzq01M8H_dkVlJJlR>:first-child{flex-grow:1}`, "",{"version":3,"sources":["webpack://./src/components/formElements/SelectCategories/SelectCategories.module.scss"],"names":[],"mappings":"AAAA,uCACE,YAAA,CACA,oBAAA,CACA,OAAA,CAEA,oDACE,WAAA","sourcesContent":[".SelectCategories {\n  display: flex;\n  align-items: baseline;\n  gap: 1em;\n\n  > :first-child {\n    flex-grow: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SelectCategories": `SelectCategories_K37Lzq01M8H_dkVlJJlR`
};
export default ___CSS_LOADER_EXPORT___;
